import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const gkmgAnchorApi = AiseaApiFactory.get("gkmgAnchor");

export default {
  /** アンカーをフェッチする */
  fetchAnchors({ commit }, payload) {
    commit("SET_ANCHORS", payload);
  },
  /** 削除されたアンカーを除外する */
  removeAnchor({ commit }, payload) {
    commit("REMOVE_ANCHOR", payload);
  },
  /** FireStoreのアンカーを論理削除する */
  async deleteAnchor(_, payload) {
    await gkmgAnchorApi.delete(payload);
  },
  /*=========================================================================================
   リセット
  ==========================================================================================*/
  async resetAnchorState({ commit }) {
    let defaultState = {
      anchors: [],
    };
    commit("RESET_STATE", defaultState);
  },
};
